import { MainMandatorType } from "@rentablo/theming";

export const getDefaultMandatorSlug = (): MainMandatorType => {
  const reactAppNameMap: Record<string, MainMandatorType> = {
    depotcheck: "depotcheck_ai",
    rentablo: "rentablo",
    finanzfluss: "finanzfluss",
    compliance: "kpmg-germany",
  };
  return reactAppNameMap[import.meta.env.VITE_APP_NAME as string] || "rentablo";
};
